import { render } from "./user-wallet.vue?vue&type=template&id=cda71d58"
import script from "./user-wallet.vue?vue&type=script&lang=js"
export * from "./user-wallet.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__